<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class="mt-1 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
      </div>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">名称</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.name}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.create_time}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.status === 1" class="text-green-600">上架</span>
                    <span v-else-if="item.status === 0">待审核</span>
                    <span class="text-red-600" :title="item.audit_remark" v-else-if="item.status === -1">未通过</span>
                    <span v-else-if="item.status === -2">禁用</span>
                    <span class="text-gray-400" v-else>下架</span>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="sellCtl(item)" title="设置">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="marketCtl(item, 'up')" title="上架" v-if="item.status === -3">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="marketCtl(item, 'down')" title="下架" v-if="item.status === 1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="deleteItem(item)" v-if="item.status < 1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.size" :page="query.page" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="detailDialog" title="评论内容" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2">
        {{content}}
      </div>
    </Modal>
    <Modal :visible.sync="sellDialog" title="设置" @submit="submitSell" width="max-w-7xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4">
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">收费类型 </label>
          </div>
          <div class="sm:col-span-7">
            <div class="sm:flex sm:items-center sm:space-y-0 sm:space-x-10 sm:pt-2">
              <div class="flex items-center cursor-pointer" @click="sellForm.sell_type = 0">
                <input name="notification-method" :value="0" type="radio" :checked="sellForm.sell_type === 0" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="email" class="ml-3 block text-sm font-medium text-gray-700"> 免费 </label>
              </div>

              <div class="flex items-center cursor-pointer" @click="sellForm.sell_type = 1">
                <input name="notification-method" :value="1" type="radio" :checked="sellForm.sell_type === 1" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="sms" class="ml-3 block text-sm font-medium text-gray-700"> 积分购买 </label>
              </div>

              <!-- <div class="flex items-center cursor-pointer" @click="sellForm.sell_type = 2">
                <input name="notification-method" :value="2" type="radio" :checked="sellForm.sell_type === 2" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="push" class="ml-3 block text-sm font-medium text-gray-700"> VIP </label>
              </div> -->
            </div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2" v-if="sellForm.sell_type === 1">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">所需积分数</label>
          </div>
          <div class="sm:col-span-7">
            <input v-model="sellForm.sell_score" type="number" autocomplete="off" name="project-name" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">内容</label>
          </div>
          <div class="sm:col-span-7">
            <div id="editormdid" style="z-index: 9999">
              <textarea style="display:none;" v-model="sellForm.content"></textarea>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <div id="imageUpload" @click.prevent="upload(false)" style="display: none;"></div>
    <div id="fileUpload" @click.prevent="upload(true)" style="display: none;"></div>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, remove, marketCtlPost, sellConfig, marketFile } from '../api/Market'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      detailDialog: false,
      query: {
        page: 1,
        size: 10,
        keyword: '',
        component_type: 4,
        sort: '-id'
      },
      content: '',
      tableData: [],
      total: 0,
      sellDialog: false,
      selectedKey: '',
      sellForm: {
        sell_type: 0,
        sell_score: 0,
        content: ''
      },
      editor: null,
      fullscreen: ''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    upload (isFile = false) {
      const file = document.querySelector(`input[name="editormd-${isFile ? 'file' : 'image'}-file"]`).files[0]
      const upData = new FormData()
      upData.append('formFile', file)
      marketFile(upData).then(res => {
        if (!res.data.success) {
          this.notifyShow({ title: res.data.message, type: 'error' })
        } else {
          this.notifyShow({ title: '文件上传成功', type: 'success' })
          document.querySelector('.editormd-dialog-container [data-url]').value = 'https://img.huoyuyan.com/' + res.data.url
          document.querySelector('.editormd-dialog-container [data-alt]').value = '附件：' + res.data.name
          document.querySelector('.editormd-enter-btn').click()
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {})
    },
    initEditor () {
      // window.editormd.emoji = {
      //   path : "https://www.webpagefx.com/tools/emoji-cheat-sheet/graphics/emojis/",
      //   ext : ".png"
      // }
      this.editor = window.editormd('editormdid', {
        height: 358,
        watch: true,
        markdown: this.sellForm.content,
        emoji: true,
        taskList: true,
        tocm: true,
        tex: true,
        flowChart: true,
        sequenceDiagram: true,
        path: '/asset/editor.md/lib/',
        imageUpload : true,
        imageFormats : ["jpg", "jpeg", "gif", "png", "bmp", "webp"],
        imageUploadURL : window.location.protocol + '//api8.huoyuyan.com/api/client/user/market/upload',
        onfullscreen: () => {
          this.fullscreen = 'max-w-full h-screen'
        },
        onfullscreenExit: () => {
          this.fullscreen = ''
        }
      })
    },
    sellCtl (row) {
      this.selectedKey = row.key
      this.sellForm.sell_type = row.sell_type
      this.sellForm.sell_score = row.sell_score
      this.sellForm.content = row.sell_score
      this.sellDialog = true
      this.$nextTick( () => {
        this.initEditor()
      })
    },
    submitSell () {
      this.sellForm.content = this.editor.getMarkdown()
      sellConfig(this.selectedKey, this.sellForm).then(() => {
        this.notifyShow({ title: '操作成功' })
        this.getList()
        this.sellDialog = false
      }).catch((err) => {
        console.log(err)
      }).finally(() => {})
    },
    marketCtl (item) {
      marketCtlPost(item.key).then(() => {
        this.notifyShow({ title: '操作成功' })
        this.getList()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {})
    },
    view (row) {
      this.content = row.comment
      this.detailDialog = true
    },
    changePage (page) {
      this.query.page = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.page = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    deleteItem (item) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(item.id).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
